import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';

const Brand_tab_Employees: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<[]>('api/v1/Regions/ByParentRegion/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    return (
        <DataTable
            name='dtRegionSubregions'
            colInfos={[
                { key: true, dataProp: 'Id', visible: false },
                { title: 'Name', dataProp: 'parentRegion.name', sort: 'asc' }
            ]}
            tableData={data}
            navigateTitle='Region'
            navigateUrl='/plm/ItemSetup/Region/'
        />
    );
}
export default Brand_tab_Employees;